import { z } from 'zod';

/** A flag do feature-flag-service (`currentFeatures(system: USER_APP)`) que libera, por
 *  viajante, as telas de evento do organizador no web-chat. O customer-api repassa só as
 *  listadas aqui; o resto da lista do legado não sai de lá. */
export const GROUP_EVENTS_FEATURE_FLAGS = ['use_intelligence_events'] as const;

export interface GroupEventsAccessInput {
  /** `currentFeatures(USER_APP)` filtradas; `null` = não resolvido. */
  featureFlags: readonly string[] | null;
}

export const GroupEventsEntrySchema = z.object({ offer: z.boolean() }).strict();
export type GroupEventsEntry = z.infer<typeof GroupEventsEntrySchema>;

const HIDDEN: GroupEventsEntry = { offer: false };

/** Se as telas de evento aparecem: todas as flags presentes. Flags não resolvidas escondem
 *  (fail-closed). */
export function groupEventsEntry(input: GroupEventsAccessInput): GroupEventsEntry {
  const { featureFlags } = input;
  if (featureFlags === null) return HIDDEN;
  return { offer: GROUP_EVENTS_FEATURE_FLAGS.every((flag) => featureFlags.includes(flag)) };
}
